<template>
  <div class="error-page">
    <div class="error-login">
      <img src="../../../assets/enterprise/logo.png" alt="" />
      <b>丽水市企业服务综合平台</b>
    </div>
    <div class="error-ul">
      <b>进入互动填报应用失败，请按照以下步骤进行：</b>
      <div class="error-li">
        <i></i>
        <span>关注丽水市企业服务综合平台</span>
      </div>
      <div class="error-li">
        <i></i>
        <span>进入企业码丽水市专区考勤打卡应用以绑定用户身份信息</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.error-page {
  // border-top: 10px solid #f8f9fc;
  padding: 0 15px;
  .error-login {
    // width: 90%;
    padding-bottom: 40px;
    margin: 30px auto 20px;
    border-bottom: 1px dashed rgba(227, 227, 227, 1);
    text-align: center;
    img {
      width: 60px;
      height: 60px;
      border-radius: 5px;
    }
    b {
      display: block;
      color: rgba(51, 51, 51, 100);
      font-size: 18px;
    }
  }
  .error-ul {
    font-size: 16px;
    b {
      display: inline-block;
      margin-bottom: 20px;
    }
    .error-li {
      margin-bottom: 16px;
      i {
        display: inline-block;
        width: 25px;
        height: 20px;
        background: url('../../../assets/enterprise/one.png') no-repeat;
        background-size: 100%;
        margin-right: 16px;
        vertical-align: top;
      }
      span {
        display: inline-block;
        width: 80%;
        line-height: 25px;
      }
    }
    .error-li:nth-child(3) {
      i {
        background: url('../../../assets/enterprise/two.png') no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>
